import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "button", "status", "progress"]
  static values = { profileId: String }

  connect() {
    this.isGenerating = false
    this.fullText = ""
  }

  // This method is called when the streaming starts
  startStreaming() {
    this.isGenerating = true
    this.fullText = ""
    this.updateUI(true)
    
    // Show the streaming container
    const streamingContainer = document.getElementById(`profile_summary_stream_${this.profileIdValue}`)
    if (streamingContainer) {
      streamingContainer.classList.remove('hidden')
    }
  }

  // This method is called for each chunk
  addChunk(event) {
    const chunk = event.detail.chunk
    if (chunk) {
      this.fullText += chunk
      this.updateStreamingText()
    }
  }

  // This method is called when streaming is complete
  completeStreaming(event) {
    this.isGenerating = false
    this.updateUI(false)
    
    // Hide the streaming container
    const streamingContainer = document.getElementById(`profile_summary_stream_${this.profileIdValue}`)
    if (streamingContainer) {
      streamingContainer.classList.add('hidden')
    }
    
    // Update the textarea with the full text
    this.updateTextarea()
    
    // Show success message
    this.showSuccess('AI-Profiltext erfolgreich generiert!')
  }

  // This method is called when there's an error
  handleError(event) {
    this.isGenerating = false
    this.updateUI(false)
    
    // Hide the streaming container
    const streamingContainer = document.getElementById(`profile_summary_stream_${this.profileIdValue}`)
    if (streamingContainer) {
      streamingContainer.classList.add('hidden')
    }
    
    this.showError('Fehler bei der AI-Generierung: ' + event.detail.error)
  }

  updateStreamingText() {
    const streamingText = document.getElementById(`streaming_text_${this.profileIdValue}`)
    if (streamingText) {
      streamingText.textContent = this.fullText
    }
  }

  updateTextarea() {
    if (this.hasTextareaTarget) {
      // Update the trix editor if it exists
      const trixEditor = this.textareaTarget.querySelector('trix-editor')
      if (trixEditor) {
        trixEditor.editor.setHTML(this.fullText)
      } else {
        // Fallback to regular textarea
        this.textareaTarget.value = this.fullText
      }
    }
  }

  updateUI(generating) {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = generating
      this.buttonTarget.innerHTML = generating 
        ? '<i class="fas fa-spinner fa-spin mr-2"></i>Generiere...' 
        : '<i class="fas fa-magic mr-2"></i>AI generieren'
    }

    if (this.hasStatusTarget) {
      this.statusTarget.textContent = generating 
        ? 'AI generiert Profiltext...' 
        : ''
    }

    if (this.hasProgressTarget) {
      this.progressTarget.style.display = generating ? 'block' : 'none'
    }
  }

  showError(message) {
    alert(message) // Simple fallback
  }

  showSuccess(message) {
    // You can implement a toast notification here
  }
}
